import $ from "jquery";
const errorPage = {
    variable:{
        url: window.location.href,
    },
    methods: {
        init: function () {
            const wrapper = $(".error__page__bg");
            const backgroundImage = wrapper.attr("data-bg-image");
            if (backgroundImage) {
                wrapper.css("background-image", `url(${backgroundImage})`);
            }
        },
        backButtonClickHandler : function () {
                     $(".error__page .chli_btn--primary").on('click', function(){
                        let buttonTitle = $(this).text().replace(/\s+/g, ' ').trim();
                        let title = $('.error__page__heading').text().replace(/\s+/g, ' ').trim();
                        let obj = errorPage.methods.dataLayerObj(buttonTitle,title);
                        createDataLayer('buttonClick', obj);
                     });
                    },

        dataLayerObj : function(e,el) {
                            var obj = {
                                'articleName' : "",
                                'blogCategory' : "",
                                'blogPageCategory' : "",
                                'buttonText' : e ? e : "",
                                'pageSection' : el ? el : "",
                                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? errorPage.variable.url.includes("blog") ? "Blogs" : errorPage.variable.url.substring(errorPage.variable.url.indexOf(".com/"), errorPage.variable.url.lastIndexOf('/')  === ".com") && !errorPage.variable.url.substring(errorPage.variable.url.indexOf(".com/"), errorPage.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                                'planOption' : "",
                                'productCategory' : "",
                                'productName' : "",
                                'question' : "",
                                'searchTerm' : "",
                                'videoTitle' : "",
                                'bannerName' : "",
                                'bannerType' : ""

                            };
                            return obj;
                        },
    },
};


$(() => {
    if ($(`.error__page`).length) {
        errorPage.methods.init();
        errorPage.methods.backButtonClickHandler();
    }
});
